<template>
  <div class="business-warp" v-loading="loading">
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <!-- <el-table-column prop="procure_id" label="ID"></el-table-column> -->
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="title" label="文章名称"></el-table-column>
          <el-table-column label="是否删除" width="100">
            <template slot-scope="scope">
              <div>
                {{ scope.row.is_delete == 0 ? "未删除" : "已删除" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
          ></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                @click="editClick(scope.row)"
                type="success"
                size="small"
                >编辑文章</el-button
              >
              <el-button @click="godelete(scope.row)" type="danger" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes,prev, pager, next, jumper"
          :total="totalDataNumber"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BusinessApi from "@/api/business.js";

export default {
  components: {},
  data() {
    return {
      loading: false,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*列表数据*/
      tableData: []
    };
  },
  created() {
    /*获取数据*/
    this.getData();
  },
  methods: {
    /*打开编辑*/
    editClick(row) {
      const rowData = JSON.stringify(row);
      localStorage.setItem("editActivityRow", rowData);
      this.$router.push({
        path: "/business/editactivity/index"
      });
    },
    // 删除
    godelete(row) {
      console.log("删除", row.id);
      this.$confirm("确定要删除当前记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let Params = {
            id: row.id
          };
          BusinessApi.deletebusiness(Params, true).then(res => {
            console.log(res, "table");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      console.log(val);
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      self.loading = true;
      this.getData();
    },
    /*获取数据*/
    getData() {
      let self = this;
      self.loading = true;
      let Params = {
        page: self.curPage,
        page_size: self.pageSize
      };
      BusinessApi.indexbusiness(Params, true)
        .then(res => {
          console.log(res);
          self.$message({
            message: "加载成功",
            type: "success"
          });
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          console.log(self.tableData, self.totalDataNumber);
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.business-warp {
  margin: 0 10vw;
  padding-bottom: 20px;
  .module {
    margin-top: 20px;
    .module-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .module-title-left {
        display: flex;
        align-items: center;
      }
      .more {
        font-weight: 400;
        font-size: 16px;
        color: #999;
        line-height: 16px;
        cursor: pointer;
      }
    }
    .article-warp {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;
      margin-left: -29px;
      .article {
        width: 347px;
        padding: 20px 24px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 16px;
        margin-bottom: 20px;
        margin-left: 29px;
        .content-warp {
          display: flex;
          .article .content-warp img {
            width: 100px;
            height: 60px;
          }
          .article .content-warp-left .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #333;
            line-height: 22px;
            margin-bottom: 16px;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .desc {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999;
            line-height: 14px;
            margin-bottom: 16px;
          }
        }
        .article .tag {
          display: inline-block;
          padding: 6px;
          border-radius: 5px;
          font-weight: 400;
          font-size: 12px;
          line-height: 12px;
          margin-top: 36px;
        }
        .article .tag.cz {
          color: #ff813a;
          background: #fff6f0;
        }
        .lines {
          height: 1px;
          width: 100%;
          background: #e9e9e9;
          margin: 20px 0 16px;
        }
        .time {
          font-weight: 400;
          font-size: 12px;
          color: #bbb;
          line-height: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/business/activity/index.vue